module.exports = __webpack_public_path__ + "media/7.9b29eadd.mp3";